<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          パターン
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">パターン</a>
          </li>
      </ul>
    </div>
      <b-row>
        <b-col lg="12" xl="12">
          <!-- 테스트 안내 메세지 -->
          <b-card v-if="is_test" class="text-center text-bold">
            <b-row>
              <b-col>
                {{ apply_request }} のエージョントに検査をリクエストします。
                <br>
                詳細検査が完了すると、自動的に保険が有効になります。
                <br>
                もしもポリシーの有効化に問題がある場合、メールが送信されます。
                <br>
                メール通知を有効にしてください。
              </b-col>
            </b-row>
            <hr>
            <b-row v-if="apply_alive != apply_request" class="text-center">
              <b-col>
                <h5 class="text-danger">{{ apply_alive }} のエージェントはオンラインですが、他のエージェントはオフラインのためパターンをテストすることができません。</h5>
                <h5 class="text-danger">パターンテストを適用する場合は、オンライン状態に切り替えて、再度テストにお進みください。 </h5>
                <h5 class="text-danger">エージェントがパターンテストを適用しない場合、隔離モードを使用するとすぐに隔離されます。今後、意図しないサービス障害が発生する可能性があります。</h5>
                <h5 class="text-danger">パターンが有効でない場合は、Q&Aまたはパートナーにお問い合わせください。</h5>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-button block size="ml" class="text-white" variant="secondary" @click="list"> 一覧 </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-else>
            <b-row>
              <b-col>
                <strong>パターンの詳細</strong>
                <span class="float-right">{{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="is_use_true">有効 / 無効</label><br/>
                <c-switch v-model="model.is_alive"  :disabled="lock" color="success" label variant="pill"/><br>
              </b-col>
              <b-col>
                <label for="ph_type">カテゴリ</label>
                <b-form-select v-model="model.category" :options="codes.code_category" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_ext">例外</label>
                <b-form-select v-model="model.ext" :options="codes.code_ext" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_type">タイプ</label>
                <b-form-select v-model="model.type" :options="codes.code_type" :disabled="lock"></b-form-select>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_code">コード</label>
                <b-form-input md="5" type="text" id="ph_code" v-model="model.code" :disabled="lock"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_content">説明</label>
                <b-form-textarea :rows="3" v-model="model.description" id="ph_content" :disabled="lock"></b-form-textarea>
              </b-col>
            </b-row>
            <hr>
            * パターンの効果を確認するために、現在の1つのパターンでスキャン全体のチェックを試みます（推奨）。
            <br>
            全数検査を無効にすることはできますが、お勧めしません。
            <br>
            チェックが終わりましたら、メールでお知らせします。
            <hr>

            <b-button class="btn-add" v-if="!lock" size="sm" variant="success" @click="modal_save = true"> 保存 </b-button>
            <b-button v-else="lock" size="sm" variant="primary" @click="edit" class="btn-add"> 編集 </b-button>
            <b-button v-if="!lock" size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
            <b-button v-else="lock" size="sm" variant="danger" @click="confirm = true"> 削除 </b-button>
            <b-button v-if="lock" size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
          </b-card>
        </b-col>
      </b-row>
    <b-modal title="削除"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
     このパターンを本当に削除してよろしいですか？
    </b-modal>
    <b-modal title="テスト"  class="modal-danger" v-model="modal_save" hide-footer ok-variant="danger">
      <h6> <span class="text-primary">テスト</span> : パターンテスト後に適用</h6>

      <h6> <span class="text-danger">保存</span> :パターンテストを省略し、即時に適用</h6>

      <hr>
      <b-button block size="sm" variant="primary" @click="test"> テスト </b-button>
      <b-button class="btn-add" block size="sm" variant="success" @click="save"> 保存 </b-button>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
